import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Loader } from 'lucide-react';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireRole?: 'landlord' | 'tenant';
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, requireRole }) => {
  const { user, profile, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="flex items-center space-x-2 text-primary">
          <Loader className="h-6 w-6 animate-spin" />
          <span>Loading...</span>
        </div>
      </div>
    );
  }

  if (!user || !profile || !user.email_confirmed_at) {
    return <Navigate to="/login" replace />;
  }

  if (requireRole && profile.role !== requireRole) {
    // Redirect based on user role
    if (profile.role === 'landlord') {
      return <Navigate to="/dashboard" replace />;
    } else {
      return <Navigate to="/tenant-portal/dashboard" replace />;
    }
  }

  return <>{children}</>;
};